<template>
  <v-app>
    <v-navigation-drawer
      v-model="primaryDrawer.model"
      :clipped="primaryDrawer.clipped"
      :mini-variant="primaryDrawer.mini"
      app
      overflow
    >
      <VuePerfectScrollbar class="scroll-area">
        <v-list nav>
          <v-list-item-group color="cyan">
            <template v-for="item in items">
              <!-- for multiple layer nav item -->
              <v-list-group
                :key="item.title"
                color="cyan"
                v-if="item.items"
                :value="$route.path.indexOf(item.parent) === 0"
              >
                <template v-slot:activator>
                  <v-list-item-icon>
                    <div class="d-flex justify-center flex-column">
                      <v-icon v-text="item.icon"></v-icon>
                      <span
                        class="px-2"
                        v-text="item.title"
                        v-if="primaryDrawer.mini"
                      ></span>
                    </div>
                  </v-list-item-icon>
                  <v-list-item-content>
                    <v-list-item-title v-text="item.title"></v-list-item-title>
                  </v-list-item-content>
                </template>

                <v-list-item
                  v-for="subItem in item.items"
                  :key="subItem.title"
                  :to="subItem.path"
                >
                  <v-list-item-icon>
                    <div class="d-flex justify-center flex-column">
                      <v-icon v-text="item.icon"></v-icon>
                      <span
                        class="px-2"
                        v-text="item.title"
                        v-if="primaryDrawer.mini"
                      ></span>
                    </div>
                  </v-list-item-icon>
                  <v-list-item-content>
                    <v-list-item-title
                      v-text="subItem.title"
                    ></v-list-item-title>
                  </v-list-item-content>
                </v-list-item>
              </v-list-group>

              <!-- for single layer nav item -->
              <v-list-item :to="item.path" :key="item.title" v-else>
                <v-list-item-icon>
                  <div class="d-flex justify-center flex-column">
                    <v-icon v-text="item.icon"></v-icon>
                    <span
                      class="px-2"
                      v-text="item.title"
                      v-if="primaryDrawer.mini"
                    ></span>
                  </div>
                </v-list-item-icon>
                <v-list-item-content>
                  <v-list-item-title v-text="item.title"></v-list-item-title>
                </v-list-item-content>
              </v-list-item>
            </template>
          </v-list-item-group>
        </v-list>
      </VuePerfectScrollbar>
    </v-navigation-drawer>
    <v-app-bar
      :clipped-left="primaryDrawer.clipped"
      app
      dark
      :color="$classStyle.mainColor"
      flat
    >
      <v-toolbar-title>寵物健檢雲平台</v-toolbar-title>
      <v-app-bar-nav-icon
        @click.stop="clickNav"
        v-if="$vuetify.breakpoint.mdAndDown"
      ></v-app-bar-nav-icon>
      <div class="flex-grow-1"></div>
      <v-menu offset-y>
        <template v-slot:activator="{ on }">
          <v-btn
            :color="$classStyle.mainColor"
            large
            dark
            v-on="on"
            elevation="0"
            class="title px-0"
          >
            {{ $my.getName() }}
            <v-icon>mdi-menu-down</v-icon>
          </v-btn>
        </template>
        <v-list>
          <v-list-item @click="goProfile()">
            <v-list-item-title>個人設定</v-list-item-title>
          </v-list-item>
          <v-list-item
            v-if="$my.getPermission() === 'role_superadmin'"
            @click="$refs.switchDialog.show()"
          >
            <v-list-item-title>診所切換</v-list-item-title>
          </v-list-item>
          <v-list-item @click="logout()">
            <v-list-item-title>登出</v-list-item-title>
          </v-list-item>
        </v-list>
      </v-menu>
    </v-app-bar>

    <v-content>
      <v-app-bar
        elevation="0"
        fixed
        :style="subHeaderStyle"
        :dense="$vuetify.breakpoint.smAndDown"
        hide-on-scroll
      >
        <v-toolbar-title>
          <v-breadcrumbs :items="breadcrumbs" large class="pl-0" divider=">">
            <template v-slot:item="{ item }">
              <a
                class="title"
                href.stop
                @click="!item.disabled ? goTo(item.to) : ''"
                :style="{
                  color: 'grey',
                  cursor: item.disabled ? 'default' : 'pointer'
                }"
                >{{ item.text }}</a
              >
            </template>
          </v-breadcrumbs>
        </v-toolbar-title>
        <div class="flex-grow-1"></div>
        <div v-if="/.*petProfile.*/.test($route.name)">
          {{ $store.state.count }}
          <v-btn
            :color="$classStyle.btnBg"
            fab
            depressed
            small
            class="mr-4"
            @click="$store.commit('triggerPetProfileEditDialog')"
          >
            <v-icon :color="$classStyle.btnColor">mdi-pencil</v-icon>
          </v-btn>
          <v-menu offset-y>
            <template v-slot:activator="{ on }">
              <v-btn :color="$classStyle.btnBg" fab depressed small v-on="on">
                <v-icon :color="$classStyle.btnColor"
                  >mdi-dots-horizontal</v-icon
                >
              </v-btn>
            </template>
            <v-list>
              <v-list-item
                @click="$store.commit('triggerPetProfileDeleteDialog')"
              >
                <v-list-item-title>刪除</v-list-item-title>
              </v-list-item>
            </v-list>
          </v-menu>
        </div>
      </v-app-bar>
      <v-container
        fluid
        :style="{
          'margin-top': $vuetify.breakpoint.smAndDown ? '48px' : ' 64px'
        }"
        class="pa-0"
      >
        <v-divider></v-divider>

        <slot></slot>
        <v-fade-transition>
          <v-btn
            v-scroll="onScroll"
            v-show="fab"
            fab
            dark
            fixed
            bottom
            right
            color="orange"
            @click="toTop"
          >
            <v-icon large class="pt-2">mdi-apple-keyboard-control</v-icon>
          </v-btn>
        </v-fade-transition>
      </v-container>
    </v-content>

    <!-- <v-footer inset app>
      <span class="px-4">&copy; {{ new Date().getFullYear() }}</span>
    </v-footer>-->
    <dialog-clinic-switch ref="switchDialog"></dialog-clinic-switch>
  </v-app>
</template>
<style scoped>
.scroll-area {
  position: relative;
  margin: auto;
  height: 100%;
}
</style>
<script>
import VuePerfectScrollbar from "vue-perfect-scrollbar";
import DialogClinicSwitch from "./DialogClinicSwitch";

export default {
  props: ["items"],
  components: {
    VuePerfectScrollbar,
    DialogClinicSwitch
  },
  data: () => ({
    primaryDrawer: {
      model: null,
      clipped: true,
      mini: true
    },
    name: JSON.parse(localStorage.getItem("authAccount")).name,
    breadcrumbs: [],
    fab: false
  }),
  computed: {
    subHeaderStyle() {
      let left = "0px";
      if (this.$vuetify.breakpoint.mdAndDown) {
        left = "0px";
      } else if (this.primaryDrawer.mini) {
        left = "80px";
      } else {
        left = "256px";
      }

      return {
        "z-index": 3,
        left: left,
        right: "0px",
        top: this.$vuetify.breakpoint.smAndDown ? "56px" : "64px"
      };
    }
  },
  watch: {
    $route: {
      handler: async function(to) {
        let result = [];
        console.log("to.name:" + to.name);
        let petName, userName;
        switch (to.name) {
          case "petManage":
            result.push({
              text: "寵物管理",
              disabled: true,
              to: "petManage"
            });
            break;
          case "accountManage":
            result.push({
              text: "帳號管理",
              disabled: true,
              to: "accountManage"
            });
            break;
          case "clinicManage":
            result.push({
              text: "診所管理",
              disabled: true,
              to: "clinicManage"
            });
            break;
          case "petProfileFromPetManage":
            result.push({
              text: "寵物管理",
              disabled: false,
              to: "petManage"
            });

            petName = await this.getPetName(to.params.petId);
            result.push({
              text: petName,
              disabled: true,
              to: "petProfileFromPetManage"
            });
            break;
          case "updateHealthReportFromPetManage":
            result.push({
              text: "寵物管理",
              disabled: false,
              to: "petManage"
            });
            petName = await this.getPetName(to.params.petId);
            result.push({
              text: petName,
              disabled: false,
              to: "petProfileFromPetManage"
            });
            result.push({
              text: "健檢報告 2019/5/6",
              disabled: true,
              to: "updateHealthReportFromPetManage"
            });
            break;
          case "createHealthReportFromPetManage":
            result.push({
              text: "寵物管理",
              disabled: false,
              to: "petManage"
            });
            petName = await this.getPetName(to.params.petId);
            result.push({
              text: petName,
              disabled: false,
              to: "petProfileFromPetManage"
            });
            result.push({
              text: "新增健檢報告",
              disabled: true,
              to: "createHealthReportFromPetManage"
            });
            break;
          case "accountProfile":
            result.push({
              text: "帳號管理",
              disabled: false,
              to: "accountManage"
            });
            userName = await this.getUserName(to.params.phone);
            result.push({
              text: userName,
              disabled: true,
              to: "accountProfile"
            });
            break;
          case "petProfileFromAccountProfile":
            result.push({
              text: "帳號管理",
              disabled: false,
              to: "accountManage"
            });
            userName = await this.getUserName(to.params.phone);
            result.push({
              text: userName,
              disabled: false,
              to: "accountProfile"
            });
            petName = await this.getPetName(to.params.petId);
            result.push({
              text: petName,
              disabled: true,
              to: "petProfileFromAccountProfile"
            });
            break;
          case "updateHealthReportFromAccountProfile":
            result.push({
              text: "帳號管理",
              disabled: false,
              to: "accountManage"
            });
            userName = await this.getUserName(to.params.phone);
            result.push({
              text: userName,
              disabled: false,
              to: "accountProfile"
            });
            petName = await this.getPetName(to.params.petId);
            result.push({
              text: petName,
              disabled: false,
              to: "petProfileFromAccountProfile"
            });
            result.push({
              text: "健檢報告 " + to.params.date.replace(/-/g, "/"),
              disabled: true,
              to: "updateHealthReportFromAccountProfile"
            });
            break;
          case "guideline":
            result.push({
              text: "使用說明",
              disabled: true,
              to: "guideline"
            });
            break;
        }
        this.breadcrumbs = result;
      },
      deep: true,
      immediate: true
    }
  },
  methods: {
    clickNav() {
      if (this.$vuetify.breakpoint.mdAndDown) {
        this.primaryDrawer.mini = true;
        this.primaryDrawer.model = !this.primaryDrawer.model;
      } else {
        this.primaryDrawer.mini = !this.primaryDrawer.mini;
      }
    },
    goProfile() {
      this.$router.push({ name: "userProfile" });
    },
    logout() {
      localStorage.removeItem("authAccount");
      this.$router.push("/");
    },
    goTo(payload) {
      this.$router.push({ name: payload });
    },
    onScroll(e) {
      if (typeof window === "undefined") return;
      const top = window.pageYOffset || e.target.scrollTop || 0;
      this.fab = top > 20;
    },
    toTop() {
      this.$vuetify.goTo(0);
    },
    async getPetName(petId) {
      let response = await this.$ajax.get(
        `${this.$config.apiUrl}/${this.$my.getClinic()}/pets/1/${petId}`
      );
      return response.data.name;
    },
    async getUserName(phone) {
      let response = await this.$ajax.post(
        `${this.$config.apiUrl}/${this.$my.getClinic()}/search/user`,
        { phone: phone }
      );
      return response.data[0].name;
    }
  },
  created() {
    console.log("VUE_APP_API_URL:" + process.env.VUE_APP_API_URL);
  }
};
</script>
